import { render, staticRenderFns } from "./CreateTokenForm.vue?vue&type=template&id=306f52a9&"
import script from "./CreateTokenForm.vue?vue&type=script&lang=js&"
export * from "./CreateTokenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports